import { HttpClient } from '@angular/common/http';
import { Component, OnInit, EventEmitter, Output, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { UrlService } from 'src/app/servicos/url.service';
import { environment } from 'src/environments/environment';
import { VersionService } from '../version.service';

@Component({
  selector: 'app-rodape',
  templateUrl: './rodape.component.html',
  styleUrls: ['./rodape.component.less']
})
export class RodapeComponent implements OnInit, AfterViewInit {
  
  versaoNumero: string = '-';
  anoAtual: number = new Date().getFullYear();

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();
  
  constructor(private versionService: VersionService) { }

  ngOnInit() {
    this.versionService.getVersion().subscribe(versionInfo => {
      this.versaoNumero = versionInfo.version;
    });
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();
  }

}
